import { msg } from '@lingui/macro';

export const BrandsRoutes = {
  path: 'brands',
  async lazy() {
    const { Parent } = await import('pages/brands');
    return { Component: Parent };
  },
  handle: {
    name: 'Brands',
    category: 'Supplier management',
    title: msg`Brands`,
  },
  children: [
    {
      path: '',
      async lazy() {
        const { Index } = await import('pages/brands');
        return { Component: Index };
      },
    },
  ],
};
